import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.jsx'
import { ErrorBoundary } from './components/ErrorBoundary'
import './index.css'

const runtime = typeof window !== 'undefined' ? window.__FIELDCERT_RUNTIME__ : undefined
const sentryDsn = (import.meta.env.VITE_SENTRY_DSN || runtime?.sentryDsn || '').trim()
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0.1),
    beforeSend(event) {
      const httpCode = event?.contexts?.response?.status_code;
      if (httpCode === 401 || httpCode === 403) return null;
      return event;
    },
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
